import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class User extends Model {
  get avatarText() {
    return this.first_name.charAt(0) + this.last_name.charAt(0)
  }

  get addedDate() {
    return dayjs.utc(this.created_at).format('MMM DD, YYYY hh:mm A')
  }

  get memberRole() {
    if (this.role === 'GROUP_LEADER') {
      return 'Student Leader'
    } else {
      return 'Student'
    }
  }
}
